
import type { ElementType, ReactNode, CSSProperties } from 'react';
import { cx } from '@client/shared/lib/cx.ts';
import styles from './layout.module.css';
import { alignClass, justifyClass, gapVar } from './Stack.tsx';
import type { SpaceToken, Align, Justify } from './Stack.tsx';

export interface RowProps {
  gap?: SpaceToken;
  align?: Align;
  justify?: Justify;
  wrap?: boolean;
  as?: ElementType;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

export function Row({
  gap,
  align,
  justify,
  wrap = false,
  as: As = 'div',
  className,
  style,
  children,
}: RowProps) {
  return (
    <As
      data-wrap={wrap}
      className={cx(
        styles.row,
        align && alignClass[align],
        justify && justifyClass[justify],
        className,
      )}
      style={{ ...gapVar(gap), ...style }}
    >
      {children}
    </As>
  );
}

export function Spacer({ className }: { className?: string }) {
  return <div className={cx(styles.grow, className)} aria-hidden="true" />;
}
